import React from 'react';
import ChangeBodyClass from '../../common/ChangeBodyClass'

class LandingLayout extends React.Component {
  render () {
    return (
      <div className='mfc-lp'>
        <ChangeBodyClass bodyClassname="mfc-lp" />

        {this.props.children}
      </div>
    )
  }
}

export default LandingLayout;
